import React from "react";
import { NavLink } from "react-router-dom";
import "./HeroSection.css";

const HeroSection = () => {
  return (
    <section className="hero">
      <div className="hero-wrapper">
        <img
          className="hero-image"
          src="/hero1.jpg" // Cambia esta ruta al path real de la imagen
          alt="Hero"
        />
        <div className="hero-content">
          <h1>Imagina. Diseña. Crea.</h1>
          <p>
            En Deluxe Labs, llevamos tus ideas al siguiente nivel con diseños
            únicos y productos personalizados.
          </p>
          <NavLink to="/productos" className="cta-btn">
            Explorar Productos
          </NavLink>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
